export default __webpack_public_path__ + "static/summer_containers69-5ef8bae565fa98af508c161092459ad4.webp";